// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3DpRE","box":"WorkspacesBox_box__2NDHV","node":"WorkspacesBox_node__3VRtm"};